import React, { useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useUserContext } from '../../peregrine/lib/context/user';

const GET_CUSTOMER_WHISHLIST = gql`
    query {
        customer {
            wishlists {
                id
                items_count
                items_v2(currentPage: 1, pageSize: 20) {
                    items {
                        id
                        description
                        product {
                            id
                            sku
                        }
                    }
                }
            }
        }
    }
`;

export const useConfiguratorShare = props => {
    const [{ isSignedIn }] = useUserContext();

    const [wishlists, setWishlists] = useState();

    const { loading, error, data } = useQuery(GET_CUSTOMER_WHISHLIST, {
        skip: !isSignedIn
    });

    useEffect(() => {
        if (data && data.customer) {
            setWishlists(data.customer.wishlists);
        }
    }, [data]);

    return {
        isSignedIn,
        loadingWishlists: loading,
        wishlists,
        ...props
    };
};
